export default {
  dict: {
    DictionaryTypeCode: '类型编码',
    DictionaryTypeName: '类型名称',
    DictionaryType: '字典类型',
    DictInfoList: '字典信息',
    CanNotBeEmpty: '不能为空',
    LengthTips: '最多90个字符',
    TypeSelect: '请选择类型'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/base/dict.js